import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    limitReached: 'You have reached your wallet limit',
  },
  fr: {
    limitReached: 'Vous avez atteint la limite de sous-comptes',
  },
} as const);

export default locales;
